module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_card-495dacd7f14e82c704617316932edd0a.svg";